
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitch03Off as ObiSwitch03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-03-off.js';
 
 
 

 
 export const ObiSwitch03Off = createComponent({
   react: React,
   tagName: 'obi-switch-03-off',
   elementClass: ObiSwitch03OffElement,
   events: {
     
   }
  });
 
 